interface Size {
    width: number;
    height: number;
}

const getBackgroundScales = (
    { clientWidth: elementWidth, clientHeight: elementHeight }: HTMLElement,
    { width: backgroundWidth, height: backgroundHeight }: Size
) => {
    const horizontalScale = elementWidth / backgroundWidth;
    const verticalScale = elementHeight / backgroundHeight;

    return { horizontalScale, verticalScale };
};

export const getBackgroundCoverScaleCompensation = (element: HTMLElement, size: Size) => {
    const { horizontalScale, verticalScale } = getBackgroundScales(element, size);

    if (horizontalScale > verticalScale) {
        return horizontalScale / verticalScale;
    }

    return verticalScale;
};

export const getDoesBackgroundCoverByHeight = (element: HTMLElement, size: Size) => {
    const { horizontalScale, verticalScale } = getBackgroundScales(element, size);

    return verticalScale > horizontalScale;
};
